"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[931],{

/***/ 8931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(150);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(3420);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(4078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(1228);
// EXTERNAL MODULE: ./node_modules/color2k/dist/index.exports.import.es.mjs
var index_exports_import_es = __webpack_require__(1175);
;// CONCATENATED MODULE: ./hooks/useColorTheme.ts


function useColorTheme(primaryColor) {
    (0,react.useEffect)(()=>{
        if (primaryColor) {
            const root = document.documentElement;
            const readablecolor = (0,index_exports_import_es/* readableColor */.XV)(primaryColor);
            root.style.setProperty("--primary-500", primaryColor || "");
            root.style.setProperty("--primary-300", (0,index_exports_import_es/* transparentize */.DZ)(primaryColor, 0.3) || "");
            root.style.setProperty("--primary-50", (0,index_exports_import_es/* transparentize */.DZ)(primaryColor, 0.85) || "");
            // It's too weird, but the Design team can do it.
            if (primaryColor === "#536DFE") {
                root.style.setProperty("--primary-readable-color", "#ffffff");
            } else {
                root.style.setProperty("--primary-readable-color", readablecolor || "");
            }
        }
    }, [
        primaryColor
    ]);
    return;
}
/* harmony default export */ var hooks_useColorTheme = (useColorTheme);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs
var useIsFetching = __webpack_require__(8420);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(8227);
;// CONCATENATED MODULE: ./hooks/useSpinner.ts



function useSpinner() {
    const isFetching = (0,useIsFetching/* useIsFetching */.y)();
    (0,react.useEffect)(()=>{
        let toastId;
        if (isFetching) {
            toastId = dist/* toast.loading */.Am.loading("Fetching...", {
                position: "top-center"
            });
        }
        return ()=>{
            dist/* toast.dismiss */.Am.dismiss(toastId);
        };
    }, [
        isFetching
    ]);
}
/* harmony default export */ var hooks_useSpinner = (useSpinner);

;// CONCATENATED MODULE: ./utils/aes.utils.ts
const secretKey = "0f3e581733534ef19cdd753c3eac0937";
const cipher = (salt)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const byteHex = (n)=>("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return (text)=>text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};
const decipher = (salt)=>{
    const textToChars = (text)=>text.split("").map((c)=>c.charCodeAt(0));
    const applySaltToChar = (code)=>textToChars(salt).reduce((a, b)=>a ^ b, code);
    return (encoded)=>encoded.match(/.{1,2}/g).map((hex)=>parseInt(hex, 16)).map(applySaltToChar).map((charCode)=>String.fromCharCode(charCode)).join("");
};
const encrypt = cipher(secretKey);
const decrypt = decipher(secretKey);
const generateOGUrl = (param)=>{
    let { title , primaryColor , logoURL  } = param;
    return encrypt(JSON.stringify({
        title,
        primaryColor,
        logoURL
    }));
};

// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./hooks/useSortWorkingHours.ts
var useSortWorkingHours = __webpack_require__(6349);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(8757);
// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 6 modules
var upperFirst = __webpack_require__(3733);
// EXTERNAL MODULE: ./node_modules/lodash-es/uniq.js + 3 modules
var uniq = __webpack_require__(5539);
;// CONCATENATED MODULE: ./containers/JSON-LD/JSON-LD.tsx







const DOMAIN_URL = "https://www.yocale.com";
const StoreJsonLd = ()=>{
    var _profile_phoneNumber, _profile_phoneNumber1, _profile_rate, _profile_rate1, _profile_rate2;
    const { t  } = (0,useTranslation/* default */.Z)("common");
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const profile = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const location = profile === null || profile === void 0 ? void 0 : profile.locations.items[0].address;
    const workingHours = profile === null || profile === void 0 ? void 0 : profile.workingHours;
    const review = profile === null || profile === void 0 ? void 0 : profile.reviews.items;
    const service = profile === null || profile === void 0 ? void 0 : profile.services.items;
    const locations = profile === null || profile === void 0 ? void 0 : profile.locations.items;
    const images = profile === null || profile === void 0 ? void 0 : profile.coverImages.map((x)=>x.url);
    const description = (profile === null || profile === void 0 ? void 0 : profile.description) || t("sections.about.description");
    var _profile_publicLinks;
    const sameAs = Object.values((_profile_publicLinks = profile === null || profile === void 0 ? void 0 : profile.publicLinks) !== null && _profile_publicLinks !== void 0 ? _profile_publicLinks : {});
    const sorting = (0,useSortWorkingHours/* default */.Z)(workingHours);
    const openingHours = (0,react.useMemo)(()=>{
        return sorting.map((x)=>{
            var _x_time, _x_time_, _x_time1, _x_time_1;
            return {
                opens: ((_x_time = x.time) === null || _x_time === void 0 ? void 0 : (_x_time_ = _x_time[0]) === null || _x_time_ === void 0 ? void 0 : _x_time_.start) || "00:00",
                closes: ((_x_time1 = x.time) === null || _x_time1 === void 0 ? void 0 : (_x_time_1 = _x_time1[0]) === null || _x_time_1 === void 0 ? void 0 : _x_time_1.end) || "00:00",
                dayOfWeek: (0,upperFirst/* default */.Z)(x.d)
            };
        });
    }, [
        sorting
    ]);
    const reviews = (0,react.useMemo)(()=>{
        return review === null || review === void 0 ? void 0 : review.map((re)=>({
                author: "".concat(re.author.firstName, " ").concat(re.author.lastName),
                datePublished: re.publishedAt,
                reviewBody: re.comment,
                reviewRating: {
                    ratingValue: re.score
                }
            }));
    }, [
        review
    ]);
    const areas = (0,react.useMemo)(()=>{
        return locations === null || locations === void 0 ? void 0 : locations.map((loc)=>({
                geoMidpoint: {
                    latitude: loc.address.geoLocation.latitude,
                    longitude: loc.address.geoLocation.longitude
                },
                geoRadius: 1000
            }));
    }, [
        locations
    ]);
    const { makesOffer , priceRange  } = (0,react.useMemo)(()=>{
        var _makesOffer_map;
        const makesOffer = service === null || service === void 0 ? void 0 : service.map((se)=>{
            return {
                priceSpecification: {
                    type: "UnitPriceSpecification",
                    priceCurrency: profile === null || profile === void 0 ? void 0 : profile.currency.name,
                    price: "".concat(se.price)
                },
                itemOffered: {
                    name: se.name,
                    description: se.description
                }
            };
        });
        const prices = (0,uniq/* default */.Z)((_makesOffer_map = makesOffer === null || makesOffer === void 0 ? void 0 : makesOffer.map((offer)=>Number(offer.priceSpecification.price))) === null || _makesOffer_map === void 0 ? void 0 : _makesOffer_map.filter((price)=>Number.isFinite(price)));
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);
        let priceRange = null;
        if (prices.length) {
            priceRange = minPrice === maxPrice ? "".concat(profile === null || profile === void 0 ? void 0 : profile.currency.name, " ").concat(profile === null || profile === void 0 ? void 0 : profile.currency.symbol).concat(minPrice) : "".concat(profile === null || profile === void 0 ? void 0 : profile.currency.name, " ").concat(profile === null || profile === void 0 ? void 0 : profile.currency.symbol).concat(minPrice, " - ").concat(profile === null || profile === void 0 ? void 0 : profile.currency.symbol).concat(maxPrice);
        }
        return {
            makesOffer,
            priceRange
        };
    }, [
        profile === null || profile === void 0 ? void 0 : profile.currency.name,
        profile === null || profile === void 0 ? void 0 : profile.currency.symbol,
        service
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, {
        type: "LocalBusiness",
        geo: {
            "@type": "GeoCoordinates",
            latitude: location === null || location === void 0 ? void 0 : location.geoLocation.latitude,
            longitude: location === null || location === void 0 ? void 0 : location.geoLocation.longitude
        },
        id: "".concat(DOMAIN_URL, "/b/").concat(profile === null || profile === void 0 ? void 0 : profile.key),
        name: (profile === null || profile === void 0 ? void 0 : profile.name) || "",
        description: description || "",
        url: "".concat(DOMAIN_URL, "/b/").concat(profile === null || profile === void 0 ? void 0 : profile.key),
        telephone: "+".concat(profile === null || profile === void 0 ? void 0 : (_profile_phoneNumber = profile.phoneNumber) === null || _profile_phoneNumber === void 0 ? void 0 : _profile_phoneNumber.countryCode).concat((profile === null || profile === void 0 ? void 0 : (_profile_phoneNumber1 = profile.phoneNumber) === null || _profile_phoneNumber1 === void 0 ? void 0 : _profile_phoneNumber1.number) || ""),
        address: {
            "@type": "PostalAddress",
            streetAddress: location === null || location === void 0 ? void 0 : location.displayAddress,
            addressLocality: location === null || location === void 0 ? void 0 : location.city,
            addressRegion: location === null || location === void 0 ? void 0 : location.state,
            postalCode: location === null || location === void 0 ? void 0 : location.postalCode,
            addressCountry: location === null || location === void 0 ? void 0 : location.country
        },
        saveAs: sameAs,
        images: images,
        openingHours: openingHours,
        ...priceRange ? {
            priceRange
        } : {},
        ...profile && (profile === null || profile === void 0 ? void 0 : (_profile_rate = profile.rate) === null || _profile_rate === void 0 ? void 0 : _profile_rate.count) > 0 ? {
            rating: {
                "@type": "AggregateRating",
                ratingValue: "".concat(profile === null || profile === void 0 ? void 0 : (_profile_rate1 = profile.rate) === null || _profile_rate1 === void 0 ? void 0 : _profile_rate1.score),
                ratingCount: "".concat(profile === null || profile === void 0 ? void 0 : (_profile_rate2 = profile.rate) === null || _profile_rate2 === void 0 ? void 0 : _profile_rate2.count),
                bestRating: 5,
                worstRating: 1
            }
        } : {},
        review: reviews,
        makesOffer: makesOffer,
        areaServed: areas
    });
};


// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./containers/Layout/Layout.tsx











const GTM_ID = "GTM-K9SZ2CD";
const Header = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(228), __webpack_require__.e(169), __webpack_require__.e(757)]).then(__webpack_require__.bind(__webpack_require__, 5757)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5757)
            ]
    },
    ssr: false
});
const Layout = (param)=>{
    let { children , businessKey , title , description , hideHeaderFooter , primaryColor , logoURL , headerProps , languages  } = param;
    hooks_useColorTheme(primaryColor);
    hooks_useSpinner();
    const cx = generateOGUrl({
        title,
        primaryColor,
        logoURL
    });
    const truncatedDesc = description && (0,utils/* truncateString */.aS)(description, 160);
    const languageAlternates = (0,react.useMemo)(()=>{
        if (!languages) return [];
        const allSupportedLanguageAlternates = languages === null || languages === void 0 ? void 0 : languages.map((lng)=>({
                hrefLang: lng,
                href: "".concat("https://www.yocale.com", "/").concat(lng, "/b/").concat(businessKey)
            }));
        const defaultAlternate = {
            hrefLang: "x-default",
            href: "".concat("https://www.yocale.com", "/b/").concat(businessKey)
        };
        return [
            ...allSupportedLanguageAlternates,
            defaultAlternate
        ];
    }, [
        languages,
        businessKey
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: (0,utils/* resolvedPublicPath */.dO)("apple-touch-icon.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: (0,utils/* resolvedPublicPath */.dO)("favicon-32x32.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: (0,utils/* resolvedPublicPath */.dO)("favicon-16x16.png")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtag-base",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer', '".concat(GTM_ID, "');\n          ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: truncatedDesc,
                canonical: "".concat("https://www.yocale.com", "/b/").concat(businessKey),
                noindex: "false" === "true",
                languageAlternates: languageAlternates,
                openGraph: {
                    url: "".concat("https://www.yocale.com", "/b/").concat(businessKey),
                    title,
                    description: truncatedDesc,
                    images: [
                        {
                            url: "".concat("https://og.planet.yocale.com", "/api/og?cx=").concat(cx),
                            width: 1200,
                            height: 630,
                            alt: title,
                            type: "image/png"
                        }
                    ]
                },
                twitter: {
                    handle: "@handle",
                    site: "@site",
                    cardType: "summary_large_image"
                }
            }),
            !hideHeaderFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreJsonLd, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "text-black",
                children: [
                    !hideHeaderFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        ...headerProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            title: "googletagmanager",
                            src: "https://www.googletagmanager.com/ns.html?id=".concat(GTM_ID),
                            height: "0",
                            width: "0",
                            style: {
                                display: "none",
                                visibility: "hidden"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Layout_Layout = (/*#__PURE__*/(0,react.memo)(Layout));


/***/ }),

/***/ 6349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1776);

const useSortWorkingHours = (workingHours)=>{
    const sorting = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (!workingHours) return [];
        const times = [];
        Object.entries(workingHours).forEach(function(param) {
            let [day, time] = param;
            times.push({
                d: day,
                time
            });
        });
        const sorter = {
            // "sunday": 0, // << if sunday is first day of week
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
            sunday: 7
        };
        times.sort((a, b)=>{
            let day1 = a.d.toLowerCase();
            let day2 = b.d.toLowerCase();
            return sorter[day1] - sorter[day2];
        });
        return times;
    }, [
        workingHours
    ]);
    return sorting;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSortWorkingHours);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; },
/* harmony export */   "vY": function() { return /* binding */ sortListByAnotherList; }
/* harmony export */ });
/* unused harmony export isProd */
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(194);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3488);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6031);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(394);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4035);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6749);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7457);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4237);




const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    const link = query_string__WEBPACK_IMPORTED_MODULE_0__/* ["default"].stringifyUrl */ .Z.stringifyUrl({
        url: "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier),
        query: {
            lng: locale,
            locations: type === "location" ? id : undefined,
            op: type === "provider" ? "~".concat(id) : type === "service" ? "".concat(id, "~") : undefined
        }
    });
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>{
    return "/b/".concat(path);
};
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    return truncateString(label, limit);
};
function sortListByAnotherList(unsortedList, sortedList) {
    let key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "id";
    if ((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(unsortedList) || (0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(sortedList)) {
        return unsortedList;
    }
    const indexedUnsortedList = (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(unsortedList, key);
    if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(sortedList[0])) {
        const diff = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(unsortedList, (item)=>item && item[key]), sortedList);
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            ...sortedList,
            ...diff
        ], (key)=>indexedUnsortedList[key]));
    } else {
        const diff1 = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(unsortedList, sortedList, key);
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)([
            ...sortedList,
            ...diff1
        ], (item)=>indexedUnsortedList[item[key]]));
    }
}



/***/ })

}]);